import { Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, FormControlLabel, DialogActions, Button, TextField, MenuItem, Checkbox, Autocomplete, Grid, Box, useMediaQuery, useTheme } from "@mui/material";
import { addDoc, collection, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "lib/firebase";
import { useEffect, useState } from "react"

const categoryOptions = ["daily", "weekly", "monthly"]
const defaultRoomOptions = ["Kitchen", "Living Room", "Dining Room", "Bedroom", "Bathroom", "Outdoors", "Basement", "General"]

const AddEditChoreDialog = ({ open, handleClose, chore, setChore, existingRooms = [] }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [newDescription, setNewDescription] = useState(chore.description)
  // Removed assignee state - defaulting to empty/unassigned for new chores
  const [newCategory, setNewCategory] = useState(chore.category?.toLowerCase())
  const [newRoom, setNewRoom] = useState(chore.room || "General")

  // Merge default options with any custom rooms found in the DB (deduplicated)
  const roomOptions = Array.from(new Set([...defaultRoomOptions, ...existingRooms])).sort();

  useEffect(() => {
    setNewDescription(chore.description)
    setNewCategory(chore.category?.toLowerCase())
    setNewRoom(chore.room || "General")
  }, [chore])

  const reset = () => {
    setNewDescription("")
    setNewCategory("daily")
    setNewRoom("General")
  }

  const updateChore = async () => {
    const commonData = {
        description: newDescription,
        assignee: "", // Explicitly clearing or setting to empty since we removed the field
        category: newCategory,
        frequency: newCategory,
        room: newRoom
    };

    if (chore.id) {
      // Update existing chore
      try {
        const choreRef = doc(db, "chores", chore.id)
        await updateDoc(choreRef, commonData)
        if (setChore) setChore(null); 
        reset()
        handleClose()
      } catch (error) {
      }
    } else {
      // Add New Chore
      try {
        await addDoc(collection(db, "chores"), commonData)
        reset()
        handleClose()
      } catch (error) {
      }
    }
  }

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this chore?")) {
        try {
            await deleteDoc(doc(db, "chores", chore.id));
            if (setChore) setChore(null);
            handleClose();
        } catch (error) {
        }
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{chore.id ? "Edit Chore" : "Add a New Chore"}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="description"
          label="Chore Description"
          type="text"
          fullWidth
          variant="outlined"
          value={newDescription}
          onChange={(e) => setNewDescription(e.target.value)}
          sx={{ mb: 2, mt: 1 }}
        />

        <Autocomplete
            freeSolo
            id="room-select"
            options={roomOptions}
            value={newRoom}
            onChange={(event, newValue) => {
                setNewRoom(newValue);
            }}
            onInputChange={(event, newInputValue) => {
                setNewRoom(newInputValue);
            }}
            renderInput={(params) => (
                <TextField 
                    {...params} 
                    label="Room / Area" 
                    variant="outlined" 
                    margin="dense" 
                    fullWidth 
                />
            )}
            sx={{ mb: 2 }}
        />

        <FormControl fullWidth margin="dense">
            <InputLabel id="cat-label">Frequency</InputLabel>
            <Select
            labelId="cat-label"
            value={newCategory}
            label="Frequency"
            onChange={(e) => setNewCategory(e.target.value)}
            >
            {categoryOptions.map((option) => (
                <MenuItem key={option} value={option}>
                {option.charAt(0).toUpperCase() + option.slice(1)}
                </MenuItem>
            ))}
            </Select>
        </FormControl>

      </DialogContent>
      <DialogActions sx={{ 
        justifyContent: isMobile ? 'center' : 'space-between', 
        px: 3, 
        pb: 2,
        flexDirection: isMobile ? 'column-reverse' : 'row',
        gap: isMobile ? 1 : 0
      }}>
        {chore.id && (
             <Button 
                onClick={handleDelete} 
                color="error" 
                fullWidth={isMobile}
                sx={{ mt: isMobile ? 1 : 0 }}
            >
                Delete
            </Button>
        )}
        <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', width: isMobile ? '100%' : 'auto', gap: 1 }}>
            <Button 
                onClick={handleClose} 
                sx={{ mr: isMobile ? 0 : 1 }} 
                fullWidth={isMobile}
            >
                Cancel
            </Button>
            <Button 
                onClick={updateChore} 
                variant="contained" 
                fullWidth={isMobile}
            >
                {chore.id ? "Save Changes" : "Add Chore"}
            </Button>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default AddEditChoreDialog;